import { render, staticRenderFns } from "./vacunas.vue?vue&type=template&id=3d636f87&scoped=true"
import script from "./vacunas.vue?vue&type=script&lang=js"
export * from "./vacunas.vue?vue&type=script&lang=js"
import style0 from "./vacunas.vue?vue&type=style&index=0&id=3d636f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d636f87",
  null
  
)

export default component.exports